export default __webpack_public_path__ + "static/media/filterNewICon.4fd6ee58.svg";